import { mapGetters, mapMutations } from 'vuex';

import { GETTERS } from '@/store/modules/app/const';
import SectionName from './SectionName';
import SectionProcess from './SectionProcess';
import { getSheetsApi } from '@/api/book';
import {
  GETTERS as BOOK_GETTERS,
  MUTATES as BOOK_MUTATES
} from '@/store/modules/book/const';

const COLLAPSE = 'collapse';
const EXPAND = 'expand';

export default {
  components: {
    SectionName,
    SectionProcess
  },
  props: {
    section: {
      type: Object,
      require: true
    },
    isEnable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpenMenu: false,
      isDragControlDisplayed: false,
      isOpenInputTags: false,
      isCollapseDetail: true
    };
  },
  computed: {
    ...mapGetters({
      sectionSelected: GETTERS.SECTION_SELECTED,
      getSheets: BOOK_GETTERS.GET_SHEETS
    })
  },
  watch: {
    sectionSelected(val) {
      this.setIsOpenMenu(val);
    }
  },
  methods: {
    ...mapMutations({
      addSheets: BOOK_MUTATES.ADD_SHEETS,
      updateSheetIds: BOOK_MUTATES.UPDATE_SHEET_IDS
    }),
    setIsOpenMenu(sectionSelected) {
      if (!sectionSelected || sectionSelected !== this.section.id) {
        this.isOpenMenu = true;
      } else if (sectionSelected && sectionSelected === this.section.id) {
        this.isOpenMenu = false;
      }
    },
    /**
     * Toggle section detail
     *
     * @param {Object}  event event fire when click on section header
     */
    async toggleDetail(event) {
      const sectionHeader = event.target.closest('.section-header');

      const isCollapse = sectionHeader.getAttribute('data-toggle') !== COLLAPSE;

      if (isCollapse) {
        this.isOpenInputTags = false;
        this.onToggleTags(true);
      }
      this.isCollapseDetail = isCollapse;

      sectionHeader.setAttribute('data-toggle', isCollapse ? COLLAPSE : EXPAND);

      const img = sectionHeader
        .querySelector('.section-name')
        .querySelector('.v-icon');

      img.setAttribute('data-toggle', isCollapse ? COLLAPSE : EXPAND);

      const targetId = sectionHeader.getAttribute('data-target');

      const { sheets, sheetIds } = await getSheetsApi(targetId);
      this.updateSheetIds({ sectionId: targetId, sheetIds });
      this.addSheets({ sheets });
      const target = document.querySelector('[data-id="' + targetId + '"]');

      target.setAttribute('data-toggle', isCollapse ? COLLAPSE : EXPAND);

      this.$root.$emit('toggleSection');
    },
    /**
     * Show the drag control when hover & enable & draggable
     */
    showDragControl() {
      this.isDragControlDisplayed = this.section.draggable;
    },
    /**
     * Hide the drag control when mouse out
     */
    hideDragControl() {
      this.isDragControlDisplayed = false;
    },
    onAddTag(value) {
      this.$emit('addTag', value);
    },
    onToggleTags(isCollapseDetail = false) {
      if (!isCollapseDetail) {
        this.isOpenInputTags = true;
      }
      this.$emit('toggleTags', isCollapseDetail);
    }
  }
};
